<video #video class = "video-js vjs-default-skin" preload = "none" crossorigin="anonymous"></video>
